module.exports = (function () {
    var getRootWindowInSameDomain = function (win) {
        var top = window;
        var win = win || window;
        
        while (win.parent != win) {
          try {
            // when the parent window is from a different domain accessing any property from window will throw cross origin access exception
            if(win.parent.document) {
                top = win.parent;
            }
          } catch (e) {}
            win = win.parent;
        }
        return top;
    };

    var view = getRootWindowInSameDomain(window);
    return {
        closeOverlay: function (response) {
            if (!!view && !!view.done) {
                view.done(response);
            }
        },
        showView: function () {
            if (!!view && !!view.show) {
                view.show();
            }
        },

        getViewMessage: function () {
            view = view && view[window.parent.name];
            if (!!view && !!view.config) {
                return view.config.message
            } else {
                return null;
            }
        }
    }
})();


//////////////////
// WEBPACK FOOTER
// ./src/auditlog/src/auditlog-ui/utils/fullscreenOverlayGuest.js
// module id = JCBv
// module chunks = 0